import { get } from '../client';

export const dashboardApi = {
  getCounts: () => get('/dashboard'),
  villageSummary: () => get('/dashboard/village-summary'),
};
